import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { LoaderState } from './loader';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();
  /** Enquanto ativo, nenhuma request reabre o overlay sozinha. */
  private automaticLoaderSuppressed = false;

  constructor() {
    // do nothing.
   }

  show(text?:string) {
    this.loaderSubject.next(<LoaderState>{ show: true,text:text });
  }

  hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }

  suppressAutomaticLoader(): void {
    this.automaticLoaderSuppressed = true;
    this.hide();
  }

  releaseAutomaticLoader(): void {
    this.automaticLoaderSuppressed = false;
  }

  isAutomaticLoaderSuppressed(): boolean {
    return this.automaticLoaderSuppressed;
  }
}
